import { FC } from "react";
import { Card, Flex, Text } from "@radix-ui/themes";

import { DataExport } from "./api";

interface DataExportSummaryProps {
  dataExport: DataExport;
}

const SummaryRow: FC<{ label: string; value: string | null | undefined }> = ({ label, value }) => (
  <Flex direction="column" gap="1">
    <Text size="2" color="gray">
      {label}
    </Text>
    <Text size="3" weight="medium" style={{ fontFamily: "monospace" }}>
      {value ?? "—"}
    </Text>
  </Flex>
);

const formatDateTime = (value: string | null | undefined) =>
  value ? new Date(value).toLocaleString() : null;

export const DataExportSummary: FC<DataExportSummaryProps> = ({ dataExport }) => {
  return (
    <Card>
      <Flex direction="column" gap="3">
        <SummaryRow label="Export ID" value={dataExport.id} />
        <SummaryRow label="Space Account ID" value={dataExport.owned_by_space_account_id} />
        <SummaryRow label="Kind" value={dataExport.kind} />
        <SummaryRow label="Started" value={formatDateTime(dataExport.started_at)} />
        <SummaryRow label="Ended" value={formatDateTime(dataExport.ended_at ?? undefined)} />
        <SummaryRow
          label="Ended With Error"
          value={
            dataExport.ended_with_error === undefined || dataExport.ended_with_error === null
              ? "—"
              : dataExport.ended_with_error
                ? "Yes"
                : "No"
          }
        />
        <SummaryRow label="Zip Path" value={dataExport.export_zip_filepath ?? undefined} />
        <SummaryRow label="Locally Created" value={formatDateTime(dataExport.locally_created_at)} />
        <SummaryRow
          label="Locally Modified"
          value={formatDateTime(dataExport.locally_modified_at)}
        />
        <SummaryRow label="Created" value={formatDateTime(dataExport.created_at)} />
        <SummaryRow label="Updated" value={formatDateTime(dataExport.updated_at)} />
      </Flex>
    </Card>
  );
};
